import {
  Collapse,
  TextField,
  Grid,
  Paper,
  Typography,
  Button,
  Divider,
  Dialog,
  DialogContent,
  CircularProgress,
  IconButton,
  Box,
  DialogTitle,
  Tooltip,
  Checkbox,
  Alert,
  Backdrop,
} from '@mui/material'
import { Formik } from 'formik'
import { useContext, useState } from 'react'
import * as Yup from 'yup'
import { GlobalContext } from '../../../../App'
import { getdoc, metodoPrograma } from '../../../../components/api'
import { DadosCadastrais } from './DadosCadastrais'
import InputMask from 'react-input-mask'
import { FaLaptopMedical } from 'react-icons/fa'
import dayjs from 'dayjs'
import { TerapiaAgendamento } from './TerapiaAgendamento'
import { ProdutoAgendamento } from './ProdutoAgendamento'
import { DocumentosPaciente } from './DocumentosPaciente'
import FileExplorer from '../../../../components/FileExplorer/FileExplorer'
import { IoCloseCircleOutline } from 'react-icons/io5'
import { setError } from '../../../../components/alerts'
import { PsychologyAltOutlined } from '@mui/icons-material'
import Questionario from '../../../questionario/componente/Questionario'
import PrimeTable from '../../../../components/PrimeTable'
import { Eye } from 'lucide-react'

export const RegistroAtendimento = ({
  atendimentoSelecionado,
  setAtendimentoSelecionado,
  setTela,
  getAtendimentos,
}) => {
  const { agenda } = useContext(GlobalContext)
  const [listaTerapia, setListaTerapia] = useState([])
  const [listaProduto, setListaProduto] = useState([])
  const [listaDocumentos, setListaDocumentos] = useState([])
  const [loadingSubmit, setLoadingSubmit] = useState(null)
  const [loadingArquivo, setLoadingArquivo] = useState(null)
  const [openDocumento, setOpenDocumento] = useState(false)
  const [urlDocumento, setUrlDocumento] = useState(null)

  const [mostraDadosCadastrais, setMostraDadosCadastrais] = useState(false)

  const [openParecerIA, setOpenParecerIA] = useState(false)
  const [questionarioResposta, setQuestionarioResposta] = useState(undefined)
  const [openModalVisualizaResposta, setOpenModalVisualizaResposta] =
    useState(false)
  const [questionarioSelecionado, setQuestionarioSelecionado] = useState(null)
  const [loadingIA, setLoadingIA] = useState(false)

  function visualizaFormulario(idResposta, idQuestionario) {
    setQuestionarioResposta({
      questionario: {
        idQuestionario,
      },
      resposta: { idResposta },
    })
    setOpenModalVisualizaResposta(true)
  }

  const initialValues = {
    dsAnamnese: '',
    dsDiagnostico: '',
    dsPrescricao: '',
    idPaciente: atendimentoSelecionado.dadosAtendimento?.[7]?.idPaciente,
    idAgenda: agenda[0],
    idImagem: atendimentoSelecionado.dadosAtendimento?.[8],
    idAgendamento: atendimentoSelecionado.dadosAtendimento?.[0],
    vlPeso: '',
    vlAltura: '',
    nrTemperatura: '',
    nrFrequenciaCardiaca: '',
    nrFrequenciaRespiratoria: '',
    nrPASistolica: '',
    nrPADiastolica: '',
    dsExamesFisicos: '',
  }

  const validationSchema = Yup.object({
    vlPeso: Yup.number().typeError('Peso deve ser um número'),
    vlAltura: Yup.number().typeError('Altura esta incorreta'),
    nrTemperatura: Yup.number().typeError('Temperatura esta incorreta'),
    nrFrequenciaCardiaca: Yup.number().typeError(
      'Frequência cardíaca deve ser um número',
    ),
    nrFrequenciaRespiratoria: Yup.number().typeError(
      'Frequência respiratória deve ser um número',
    ),
    nrPASistolica: Yup.number().typeError('PA sistólica deve ser um número'),
    nrPADiastolica: Yup.number().typeError('PA diastólica deve ser um número'),
  })

  function getImc(peso, altura) {
    if (!peso || !altura) {
      return ''
    }
    return isNaN((peso / (altura * altura)).toFixed(2))
      ? ''
      : (peso / (altura * altura)).toFixed(2)
  }

  const executaAnaliseIA = async (setFieldValue) => {
    setLoadingIA(true)

    const payload = {
      idResposta: questionarioSelecionado,
      idAgente: agenda[30],
    }
    metodoPrograma('executaAnaliseQuestionarioPorIA', payload).then(
      (response) => {
        if (response.status) {
          if (response.conteudo) {
            setFieldValue('dsAnamnese', response.conteudo)
          }

          if (response.conclusao) {
            setFieldValue('dsDiagnostico', response.conclusao)
          }
        }
        setLoadingIA(false)
        setOpenParecerIA(false)
      },
    )
  }

  const salvaHistoricoPaciente = (values) => {
    if (
      agenda[0] !== 21 &&
      (values.dsDiagnostico === undefined || values.dsDiagnostico === '')
    ) {
      setError(
        `${agenda[25] !== '' ? agenda[25] : 'Diagnóstico'} é obrigatório`,
      )
      return
    }
    setLoadingSubmit(true)
    const obj = {
      ...values,
      vlPeso: values.vlPeso ? parseFloat(values.vlPeso).toFixed(2) : undefined,
      vlAltura: values.vlAltura ? parseFloat(values.vlAltura) : undefined,
      nrTemperatura: values.nrTemperatura
        ? parseFloat(values.nrTemperatura)
        : undefined,
      nrFrequenciaCardiaca: values.nrFrequenciaCardiaca
        ? parseFloat(values.nrFrequenciaCardiaca)
        : undefined,
      nrFrequenciaRespiratoria: values.nrFrequenciaRespiratoria
        ? parseFloat(values.nrFrequenciaRespiratoria)
        : undefined,
      nrPASistolica: values.nrPASistolica
        ? parseFloat(values.nrPASistolica)
        : undefined,
      nrPADiastolica: values.nrPADiastolica
        ? parseFloat(values.nrPADiastolica)
        : undefined,
      listaTerapia,
      listaProduto,
      listaDocumentos,
    }
    metodoPrograma('salvaHistoricoPaciente', obj)
      .then((response) => {
        if (response.status) {
          const newHistorico = [
            obj.idPaciente,
            obj.idAgendamento,
            dayjs().format('YYYY-MM-DD HH:mm:ss'),
            null,
            null,
            obj.dsAnamnese,
            obj.dsDiagnostico,
            obj.dsPrescricao,
            null,
            obj.vlPeso,
            obj.vlAltura,
            obj.nrTemperatura,
            obj.nrFrequenciaRespiratoria,
            obj.nrFrequenciaCardiaca,
            obj.nrPASistolica,
            obj.nrPADiastolica,
            obj.dsExamesFisicos,
            null,
          ]
          setAtendimentoSelecionado({
            historicoClinico: [
              newHistorico,
              ...atendimentoSelecionado.historicoClinico,
            ],
            dadosAtendimento: atendimentoSelecionado.dadosAtendimento,
          })
          setTela('lista')
          getAtendimentos()
        }
      })
      .finally(() => {
        setLoadingSubmit(false)
      })
  }

  const handleVisualizar = async (arquivo) => {
    const token = arquivo?.[4]

    if (!token) return

    setLoadingArquivo(token)

    try {
      // Libera a URL anterior
      if (urlDocumento) {
        URL.revokeObjectURL(urlDocumento)
      }

      const res = await getdoc(token)
      const blob = await res.blob()

      const novaUrl = URL.createObjectURL(blob)

      setUrlDocumento(novaUrl)
      setOpenDocumento(true)
    } finally {
      setLoadingArquivo(null)
    }
  }

  const handleFecharDocumento = () => {
    if (urlDocumento) {
      URL.revokeObjectURL(urlDocumento)
    }

    setUrlDocumento(null)
    setOpenDocumento(false)
  }

  return (
    <>
      <Backdrop
        open={loadingIA}
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          flexDirection: 'column',
          gap: 2,
          backgroundColor: 'rgba(0,0,0,0.85)',
        }}
      >
        <CircularProgress color="inherit" size={60} />

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h6" fontWeight={600}>
            🧠 Assistente 3Sync IA em processamento...
          </Typography>

          <Typography variant="body2" sx={{ mt: 1, opacity: 0.85 }}>
            Aguarde alguns instantes. Este processo pode levar alguns segundos.
          </Typography>
        </Box>
      </Backdrop>
      <Dialog
        open={openModalVisualizaResposta}
        onClose={() => setOpenModalVisualizaResposta(false)}
        fullWidth
        maxWidth="xl"
      >
        <DialogTitle>Visualizando Resposta</DialogTitle>
        <DialogContent>
          <Grid item xs={12}>
            <Questionario
              questionario={questionarioResposta}
              setQuestionario={setQuestionarioResposta}
              dsNome={atendimentoSelecionado?.dadosAtendimento[7]?.nmPaciente}
              idPaciente={
                atendimentoSelecionado?.dadosAtendimento[7]?.idPaciente
              }
              duplicar={false}
              disabled={true}
            />
          </Grid>
        </DialogContent>
      </Dialog>

      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h1>
          {atendimentoSelecionado.dadosAtendimento[7].nmPaciente} -{' '}
          {atendimentoSelecionado.dadosAtendimento[7].nrIdade} anos{' '}
          {atendimentoSelecionado.dadosAtendimento[7].dsAlergia !== undefined &&
            atendimentoSelecionado.dadosAtendimento[7].dsAlergia !== '' && (
              <span style={{ color: 'red' }}> - Alérgico</span>
            )}
        </h1>
        <Button
          style={{ height: '40px' }}
          onClick={() => setMostraDadosCadastrais(!mostraDadosCadastrais)}
          variant="contained"
          color={mostraDadosCadastrais ? 'primary' : 'inherit'}
        >
          Dados cadastrais
        </Button>
      </Grid>
      <Collapse in={mostraDadosCadastrais}>
        <DadosCadastrais
          pacienteSelecionado={atendimentoSelecionado.dadosAtendimento[7]}
          onConfirm={() => {
            setMostraDadosCadastrais(false)
            getAtendimentos()
          }}
          onCancel={() => setMostraDadosCadastrais(false)}
        />
      </Collapse>
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={(values, { setSubmitting }) => {
          salvaHistoricoPaciente(values)
          setSubmitting(false)
        }}
      >
        {({
          submitForm,
          getFieldMeta,
          setFieldValue,
          handleChange,
          values,
          errors,
        }) => (
          <Grid container spacing={2}>
            <Dialog
              maxWidth="lg"
              fullWidth
              open={openParecerIA}
              onClose={() => setOpenParecerIA(false)}
            >
              <DialogTitle
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                <PsychologyAltOutlined color="primary" fontSize="large" />
                Assistente Virtual 3Sync
              </DialogTitle>

              <DialogContent dividers>
                <Typography variant="body1">
                  O <strong>Assistente IA 3Sync</strong> auxilia na elaboração
                  de pareceres e registros clínicos com sugestões geradas por
                  Inteligência Artificial.
                </Typography>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mt: 2 }}
                >
                  Para iniciar,{' '}
                  <strong>selecione na tabela abaixo o questionário</strong> que
                  será utilizado como base de conhecimento para a análise da IA.
                </Typography>

                <Grid item xs={12}>
                  <PrimeTable
                    key={questionarioSelecionado}
                    codigo="CtrlAtendimentoMedico"
                    action="listaQuestionarioPaciente"
                    parametros={{
                      idPaciente:
                        atendimentoSelecionado?.dadosAtendimento[7]?.idPaciente,
                      idAgenda: agenda[0],
                    }}
                    habSearch={false}
                    rows={10}
                    head={['', 'Questionário', 'Resposta', '']}
                    line={(item) => [
                      <Checkbox
                        key={item[0]}
                        checked={questionarioSelecionado === item[0]}
                        onChange={() => setQuestionarioSelecionado(item[0])}
                      />,
                      item[3],
                      item[2],
                      <>
                        <Tooltip title="Visualizar formulário">
                          <IconButton
                            key={item[0]}
                            onClick={() =>
                              visualizaFormulario(item[0], item[1])
                            }
                          >
                            <Eye size={18} />
                          </IconButton>
                        </Tooltip>
                      </>,
                    ]}
                    collumnsDateHour={[2]}
                  />
                </Grid>

                {questionarioSelecionado && (
                  <Button
                    fullWidth
                    size="large"
                    variant="contained"
                    startIcon={<PsychologyAltOutlined />}
                    onClick={() => executaAnaliseIA(setFieldValue)}
                    sx={{
                      mt: 3,
                      py: 1.6,
                      borderRadius: 3,
                      textTransform: 'none',
                      fontSize: '1rem',
                      fontWeight: 500,
                      color: 'white',
                      background:
                        'linear-gradient(90deg, #59a68d 0%, #7dc5ae 100%)',
                      boxShadow: '0 6px 20px rgba(91,141,239,0.35)',
                      transition: 'all .25s',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: '0 10px 28px rgba(91,141,239,0.45)',
                      },
                    }}
                  >
                    Iniciar análise inteligente com 3Sync IA
                  </Button>
                )}

                <Alert severity="info" sx={{ mt: 3 }}>
                  <strong>Importante:</strong> As sugestões geradas possuem
                  caráter de apoio e{' '}
                  <strong>não substituem a avaliação do profissional</strong>.
                  Revise o conteúdo, realize os ajustes necessários e lembre-se
                  de que a responsabilidade pelo registro final é exclusivamente
                  do profissional responsável pelo atendimento.
                </Alert>

                {/* Tabela de questionários */}
              </DialogContent>
            </Dialog>
            {agenda[13] === 'S' && (
              <Grid item xs={12}>
                <Paper
                  elevation={2}
                  style={{
                    backgroundColor: '#fcfcfc',
                    borderRadius: '12px',
                    padding: '20px',
                    marginTop: '16px',
                  }}
                >
                  <Typography variant="h6" style={{ fontWeight: 300 }}>
                    Avaliações do Check-in
                  </Typography>
                  <Divider style={{ marginBottom: 10 }} />
                  {atendimentoSelecionado.dadosAtendimento?.[10]?.map(
                    (hist) => (
                      <Grid key={hist[1]} item xs={12}>
                        <TextField
                          label={hist[2]}
                          disabled
                          fullWidth
                          multiline
                          minRows={3}
                          maxRows={20}
                          variant="outlined"
                          margin="dense"
                          value={hist[4]}
                        />
                        {hist[5] && (
                          <div style={{ textAlign: 'right' }}>
                            <Dialog
                              open={openDocumento}
                              onClose={handleFecharDocumento}
                              maxWidth={false}
                              PaperProps={{
                                sx: {
                                  width: '90vw',
                                  height: '90vh',
                                  maxWidth: '90vw',
                                  maxHeight: '90vh',
                                  backgroundColor: '#000',
                                  overflow: 'hidden',
                                  boxShadow: 'none',
                                },
                              }}
                            >
                              <IconButton
                                onClick={handleFecharDocumento}
                                sx={{
                                  position: 'absolute',
                                  top: 2,
                                  zIndex: 9999,
                                  color: '#fff',
                                  backgroundColor: 'rgba(0,0,0,0.5)',
                                  '&:hover': {
                                    backgroundColor: 'rgba(0,0,0,0.7)',
                                  },
                                }}
                              >
                                <IoCloseCircleOutline />
                              </IconButton>

                              <DialogContent
                                sx={{
                                  p: 0,
                                  width: '100%',
                                  height: '100%',
                                  overflow: 'hidden',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  backgroundColor: '#000',
                                }}
                              >
                                <img
                                  key={urlDocumento}
                                  src={urlDocumento}
                                  alt="Documento"
                                  style={{
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                    width: 'auto',
                                    height: 'auto',
                                    objectFit: 'contain',
                                    display: 'block',
                                  }}
                                />
                              </DialogContent>
                            </Dialog>
                            <FileExplorer
                              arquivos={hist[5]}
                              loadingToken={loadingArquivo}
                              onClickArquivo={handleVisualizar}
                            />
                          </div>
                        )}
                        <div style={{ textAlign: 'right', marginTop: 14 }}>
                          {hist[3]} - {hist[1]}
                        </div>
                      </Grid>
                    ),
                  )}
                </Paper>
              </Grid>
            )}

            <Grid item xs={12}>
              <Paper
                elevation={2}
                style={{
                  backgroundColor: '#eff7ed',
                  borderRadius: '12px',
                  padding: '20px',
                  marginTop: '16px',
                }}
              >
                <Typography variant="h6" style={{ fontWeight: 300 }}>
                  Registro de Atendimento
                </Typography>
                <Divider style={{ marginBottom: 10 }} />
                {agenda[14] === 'S' && (
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={3} md={3} lg={3}>
                      <TextField
                        type="number"
                        label="Peso"
                        name="vlPeso"
                        fullWidth
                        variant="outlined"
                        margin="dense"
                        size="small"
                        onChange={handleChange}
                        value={values.vlPeso}
                        error={errors.vlPeso}
                        helperText={errors.vlPeso}
                        sx={{
                          backgroundColor: '#fff',
                          borderRadius: '8px',
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3}>
                      <InputMask
                        mask="9.99"
                        value={getFieldMeta('vlAltura').value}
                        onChange={(e) => {
                          const formattedValue = e.target.value
                          setFieldValue('vlAltura', formattedValue)
                        }}
                      >
                        {() => (
                          <TextField
                            label="Altura"
                            name="vlAltura"
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            size="small"
                            error={errors.vlAltura}
                            helperText={errors.vlAltura}
                            sx={{
                              backgroundColor: '#fff',
                              borderRadius: '8px',
                            }}
                          />
                        )}
                      </InputMask>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3}>
                      <TextField
                        disabled
                        label="IMC"
                        name="vlImc"
                        value={getImc(
                          getFieldMeta('vlPeso').value,
                          getFieldMeta('vlAltura').value,
                        )}
                        fullWidth
                        size="small"
                        variant="outlined"
                        margin="dense"
                        onChange={handleChange}
                        error={errors.vlImc}
                        helperText={errors.vlImc}
                        sx={{
                          backgroundColor: '#fff',
                          borderRadius: '8px',
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3}>
                      <InputMask
                        mask="99.9"
                        value={getFieldMeta('nrTemperatura').value}
                        onChange={(e) => {
                          const formattedValue = e.target.value.replace(
                            ',',
                            '.',
                          )
                          setFieldValue('nrTemperatura', formattedValue)
                        }}
                      >
                        {() => (
                          <TextField
                            label="Temperatura"
                            name="nrTemperatura"
                            fullWidth
                            size="small"
                            variant="outlined"
                            margin="dense"
                            error={errors.nrTemperatura}
                            helperText={errors.nrTemperatura}
                            sx={{
                              backgroundColor: '#fff',
                              borderRadius: '8px',
                            }}
                          />
                        )}
                      </InputMask>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3}>
                      <TextField
                        type="number"
                        label="Freq. respiratória"
                        name="nrFrequenciaRespiratoria"
                        fullWidth
                        size="small"
                        variant="outlined"
                        margin="dense"
                        onChange={handleChange}
                        value={values.nrFrequenciaRespiratoria}
                        sx={{
                          backgroundColor: '#fff',
                          borderRadius: '8px',
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3}>
                      <TextField
                        type="number"
                        label="Freq. cardíaca"
                        name="nrFrequenciaCardiaca"
                        fullWidth
                        size="small"
                        variant="outlined"
                        margin="dense"
                        onChange={handleChange}
                        value={values.nrFrequenciaCardiaca}
                        sx={{
                          backgroundColor: '#fff',
                          borderRadius: '8px',
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3}>
                      <TextField
                        type="number"
                        label="PA sistólica"
                        name="nrPASistolica"
                        fullWidth
                        size="small"
                        variant="outlined"
                        margin="dense"
                        onChange={handleChange}
                        value={values.nrPASistolica}
                        sx={{
                          backgroundColor: '#fff',
                          borderRadius: '8px',
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3}>
                      <TextField
                        type="number"
                        label="PA Diastólica"
                        name="nrPADiastolica"
                        fullWidth
                        size="small"
                        variant="outlined"
                        margin="dense"
                        onChange={handleChange}
                        value={values.nrPADiastolica}
                        sx={{
                          backgroundColor: '#fff',
                          borderRadius: '8px',
                        }}
                      />
                    </Grid>
                  </Grid>
                )}
                <Grid container spacing={2} style={{ marginTop: 10 }}>
                  {agenda[15] === 'S' && (
                    <Grid item xs={12}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        label={agenda[28] !== '' ? agenda[28] : 'Anamnese'}
                        name="dsAnamnese"
                        fullWidth
                        multiline
                        minRows={5}
                        variant="outlined"
                        margin="dense"
                        onChange={handleChange}
                        value={values.dsAnamnese}
                        sx={{
                          backgroundColor: '#fff',
                          borderRadius: '8px',
                        }}
                      />
                    </Grid>
                  )}
                  {agenda[16] === 'S' && (
                    <Grid item xs={12}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        label="Exame Físico"
                        name="dsExamesFisicos"
                        fullWidth
                        multiline
                        minRows={5}
                        variant="outlined"
                        margin="dense"
                        onChange={handleChange}
                        value={values.dsExamesFisicos}
                        sx={{
                          backgroundColor: '#fff',
                          borderRadius: '8px',
                        }}
                      />
                    </Grid>
                  )}
                  {agenda[17] === 'S' && (
                    <Grid item xs={12}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        label={agenda[25] !== '' ? agenda[25] : 'Diagnóstico'}
                        name="dsDiagnostico"
                        fullWidth
                        multiline
                        minRows={6}
                        variant="outlined"
                        margin="dense"
                        onChange={handleChange}
                        value={values.dsDiagnostico}
                        sx={{
                          backgroundColor: '#fff',
                        }}
                      />

                      {agenda[29] === 'S' && agenda[30] && (
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            mt: 1,
                          }}
                        >
                          <Button
                            size="small"
                            variant="contained"
                            onClick={() => setOpenParecerIA(true)}
                            startIcon={
                              <PsychologyAltOutlined fontSize="small" />
                            }
                            sx={{
                              bgcolor: '#59a68d',
                              color: '#ffffff',
                              textTransform: 'none',
                              borderRadius: 5,
                              px: 1.5,
                              py: 0.5,
                              boxShadow: 1,
                              '&:hover': {
                                bgcolor: '#4b907b',
                              },
                            }}
                          >
                            3Sync IA
                          </Button>
                        </Box>
                      )}
                    </Grid>
                  )}
                  {agenda[18] === 'S' && (
                    <Grid item xs={12}>
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        label="Conduta"
                        name="dsPrescricao"
                        fullWidth
                        multiline
                        minRows={5}
                        variant="outlined"
                        margin="dense"
                        onChange={handleChange}
                        value={values.dsPrescricao}
                        sx={{
                          backgroundColor: '#fff',
                          borderRadius: '8px',
                        }}
                      />
                    </Grid>
                  )}
                </Grid>
                {agenda[26] === 'S' && (
                  <Grid item xs={12} style={{ marginTop: 25 }}>
                    <DocumentosPaciente onChange={setListaDocumentos} />
                  </Grid>
                )}
                {(atendimentoSelecionado?.dadosAtendimento?.[4]
                  ?.idTipoAgendamento === 1 ||
                  atendimentoSelecionado?.dadosAtendimento?.[4]
                    ?.idTipoAgendamento === 2) && (
                  <>
                    {agenda[19] === 'S' &&
                      atendimentoSelecionado?.dadosAtendimento?.[4]
                        ?.idTipoAgendamento === 1 && (
                        <Grid item xs={12}>
                          <Paper
                            elevation={2}
                            style={{
                              marginTop: 30,
                              backgroundColor: '#ffffff', // cinza bem claro
                              borderRadius: '12px', // bordas arredondadas
                              padding: '16px',
                            }}
                          >
                            <Typography
                              variant="h6"
                              style={{ marginBottom: '10px', fontWeight: 500 }}
                            >
                              Terapias Complementares
                            </Typography>
                            <TerapiaAgendamento
                              listaTerapia={listaTerapia}
                              setListaTerapia={setListaTerapia}
                              idAgendamento={
                                atendimentoSelecionado.dadosAtendimento?.[0]
                              }
                            />
                          </Paper>
                        </Grid>
                      )}
                    {agenda[20] === 'S' && (
                      <Grid item xs={12}>
                        <Paper
                          elevation={2}
                          style={{
                            marginTop: 30,
                            backgroundColor: '#ffffff', // cinza bem claro
                            borderRadius: '12px', // bordas arredondadas
                            padding: '16px',
                          }}
                        >
                          <Typography
                            variant="h6"
                            style={{ marginBottom: '10px', fontWeight: 500 }}
                          >
                            Suplementos Complementares
                          </Typography>
                          <ProdutoAgendamento
                            listaProduto={listaProduto}
                            setListaProduto={setListaProduto}
                            idAgendamento={
                              atendimentoSelecionado.dadosAtendimento?.[0]
                            }
                          />
                        </Paper>
                      </Grid>
                    )}

                    <Grid
                      item
                      xs={12}
                      style={{ textAlign: 'end', marginTop: 25 }}
                    >
                      <Button
                        onClick={submitForm}
                        variant="contained"
                        fullWidth
                        disabled={loadingSubmit}
                        style={{ color: 'white', borderRadius: 20 }}
                      >
                        {loadingSubmit ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          <>
                            <FaLaptopMedical
                              style={{
                                fontSize: '30px',
                                marginRight: 20,
                                color: 'white',
                              }}
                            />
                            Registrar Atendimento
                          </>
                        )}
                      </Button>
                    </Grid>
                  </>
                )}
              </Paper>
            </Grid>
          </Grid>
        )}
      </Formik>
    </>
  )
}
